import { IIconButtonProps, IconButton } from './IconButton';

import { ButtonVariant } from 'react-bootstrap/esm/types';

export interface ILoadingButtonProps extends IIconButtonProps {
    icon?: string | React.ReactNode;
    loading?: boolean;
    loadingText?: string;
    variant?: ButtonVariant;
}

export function LoadingButton(props: ILoadingButtonProps) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { icon, loading, loadingText, ...rest } = props;

    return (
        <IconButton
            {...rest}
            disabled={props.disabled || props.loading}
            text={props.loading ? props.loadingText : props.text}
            icon={props.loading ? 'fal fa-spinner fa-solid fa-spin' : props.icon}
        />
    );
}
